import { render, staticRenderFns } from "./SidebarNavigation.vue?vue&type=template&id=2aa06e5b&scoped=true"
import script from "./SidebarNavigation.vue?vue&type=script&lang=js"
export * from "./SidebarNavigation.vue?vue&type=script&lang=js"
import style0 from "./SidebarNavigation.vue?vue&type=style&index=0&id=2aa06e5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa06e5b",
  null
  
)

export default component.exports